import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

export default (state) => resolveProp('cookiePolicy.accepted', state) || false;
